/**
 * Dates and times as the app shows them: British English, in Bucharest's time
 * (go-live, 2026-11-01). The browser's own locale and zone made one date read
 * differently from person to person, and a US-set laptop showed 11/30/2026.
 */
export const APP_LOCALE = 'en-GB';
export const APP_TIME_ZONE = 'Europe/Bucharest';

/** A moment (ISO string, Date or epoch ms) formatted in Bucharest. */
export function formatAppDate(value: string | number | Date | null | undefined, options: Intl.DateTimeFormatOptions): string {
  if (value === null || value === undefined || value === '') return '';
  const d = new Date(value);
  // A missing or broken date shows nothing rather than taking the page down.
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(APP_LOCALE, { timeZone: APP_TIME_ZONE, ...options }).format(d);
}

/** Hours and minutes in Bucharest, e.g. 14:05. */
export function formatAppTime(value: string | number | Date | null | undefined): string {
  return formatAppDate(value, { hour: '2-digit', minute: '2-digit' });
}
